import { FeatureId } from "@client/resources/ClinicFeatureResource";
import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { number, object } from "yup";

export interface ClinicFeatureUsageResource {
  limit: number;
  used: number;
}

export type FetchClinicFeatureUsageResponse =
  ApiResponse<ClinicFeatureUsageResource>;

export const fetchClinicFeatureUsage = async (
  featureId: FeatureId | number,
): Promise<FetchClinicFeatureUsageResponse> => {
  const response = await fetchData(
    `/dietitian/clinic/subscription/features/${featureId}/usage`,
    APIMethods.GET,
  );

  return await schema
    .validate(response)
    .catch(
      logFetchValidateError(
        `/dietitian/clinic/subscription/features/${featureId}/usage`,
      ),
    );
};

const schema = object({
  data: object({
    limit: number().required(),
    used: number().required(),
  }).required(),
});
